import { useMemo } from 'react'
import { useSelectedProperty } from '../components/BridgingFinance/store'

export const usePropertyDetails = () => {
  const { selectedProperty } = useSelectedProperty()
  const address = useMemo(() => {
    let details = ''
    if (!selectedProperty)
      return (document.getElementById('hfAddressDetails') as HTMLInputElement)
        ?.value
    if (selectedProperty.erfNo) {
      const containsSuburb = selectedProperty?.address?.includes(',')
      let addition = ''
      if (!containsSuburb) addition = `, ${selectedProperty?.suburb || ''}`
      details += `${selectedProperty?.address || '' + addition}`
      return details
    }
    // else is sectional title
    details += `${selectedProperty?.schemeName || ''}, Section ${
      selectedProperty.flatNo ? ` Unit ${selectedProperty.flatNo || ''}, ` : ''
    } ${selectedProperty?.address || ''}`
    return details
  }, [selectedProperty])

  const owners = useMemo(() => {
    if (!selectedProperty) return []
    if (!selectedProperty.owner) return []
    return selectedProperty.owner.split(';').map((owner) => owner)
  }, [selectedProperty])

  return {
    erfNo: selectedProperty?.erfNo,
    address,
    schemeNo: selectedProperty?.schemeNo,
    sectionNo: selectedProperty?.sectionNo,
    schemeName: selectedProperty?.schemeName,
    owners,
  }
}
